import React from 'react'
import { Form, Row, Col,  Label } from 'reactstrap'
import { Validator } from 'components/validation'
import { ValidationResultButton } from 'components/buttons'
import { Select } from 'components/select'
import { DialogBase, dialogSizes } from 'dialogs/dialogBase'
import dialogTypes from 'dialogs/dialogTypes'
import { AddItemButton } from 'components/buttons'
import { Input } from 'components/inputs'
import { api as winesApi } from 'store/modules/lookups/wines'

export class OrderedWineDialog extends DialogBase {
  constructor (props, context) {
    super(props, context)

    this.state = {
      entity: { ...props.context.initialState },
      index: props.context.index
    }
  }
  handleSave = () => {
    const { entity, index } = this.state
    entity.currencyName = entity.currency ? entity.currency.name : null
    this.props.context.onSaved({ entity, index })

    this.close()
  }
  modalTitle () { return this.props.localize('orderedWineDialog.title') }
  modalSize () { return dialogSizes.XL }
  modalButtons () { return <ValidationResultButton onClick={this.handleSave} /> }
  updateEntity (propName) { return x => this.setState({ entity: {...this.state.entity, [propName]: x} }) }
  modalBody () {
    const { localize, disabled } = this.props
    const { entity } = this.state
    return (
      <Form>
        <Row>
          <Col sm={7}>
            <Label>{localize('orderedWineDialog.wine')}</Label>
            <AddItemButton dialogType={dialogTypes.wineDetail} onCreatedEntity={this.updateEntity('wine')}>
              <Validator name='wine' value={entity.wine} required disabled={disabled}>
                <Select
                  dataSource={winesApi.get}
                  value={entity.wine}
                  onChange={this.updateEntity('wine')}
                  disabled={disabled} />
              </Validator>
            </AddItemButton>
          </Col>
          <Col sm={2}>
            <Label>{localize('orderedWineDialog.units')}</Label>
            <Validator name='units' value={entity.units} min={1} disabled={disabled}>
              <Input isNumeric value={entity.units} onChange={this.updateEntity('units')} placeholder={localize('orderedWineDialog.units')} />
            </Validator>
          </Col>
          <Col sm={3}>
            <Label>{localize('orderedWineDialog.price')}</Label>
            <Validator name='acquisitionPrice' value={entity.acquisitionPrice} required disabled={disabled}>
              <Input isNumeric value={entity.acquisitionPrice} onChange={this.updateEntity('acquisitionPrice')}
                placeholder={localize('orderedWineDialog.price')} disabled={disabled}
                />
            </Validator>
          </Col>
        </Row>
      </Form>
    )
  }
}

export default OrderedWineDialog
